"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "seveso": {
    "64ac9fc9": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "skipSearch": false
    }],
    "baruccana": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "271a2da6": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "skipSearch": false
    }],
    "meredo": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f36c3c5": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-martire": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bc4b38b8": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "skipSearch": false
    }],
    "seveso-centro": [{
      "hkey": "c7920d64",
      "slug": "seveso",
      "name": "Seveso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;